import React from "react";
import { modules } from "../data/content";
export function Program() {
  return <section id="programa" className="bg-ink-2" data-id="element-103" data-mp="f1l733gh77vv">
      <div className="mx-auto max-w-5xl px-6 py-16 sm:py-24" data-id="element-104" data-mp="ezqo3uorlpuf">
        <h2 className="mb-6 font-serif text-[30px] font-bold leading-tight sm:text-5xl" data-id="element-105" data-mp="a1p0cwge92cm">
          La formación que acompaña tu proceso
        </h2>
        <ol className="grid gap-5 md:grid-cols-2" data-id="element-106" data-mp="54ylgcgbscss">
          {modules.map((m, i) => <li key={m.title} className="border-b border-line pb-5" data-id="element-107" data-mp="12qdyqnq2etko" data-mpi={i}>
              <p className="mb-2 text-sm text-accent" data-id="element-108" data-mp="xsuixjdpy8qm">Módulo {i + 1}</p>
              <h3 className="mb-2 font-semibold" data-id="element-109" data-mp="ssg8juonampf">{m.title}</h3>
              <p className="leading-relaxed text-soft" data-id="element-110" data-mp="sqwumaqgonqt">{m.description}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}